import * as React from 'react'
import CustomTabs from '../shared/CustomTabs'
import { EditorTab } from './types'
import { useEditorTabs } from './useEditor'
import TemplateSelector from '../templateManagement/TemplateSelector'

/**
 * EditorTabs: Context-aware editor tab controller
 *
 * Uses editor context for tab management instead of props.
 * TemplateSelector remains unchanged using its own template context.
 */
const EditorTabs = () => {
	const { activeTab, switchTab } = useEditorTabs()

	const editorTabs = [
		{
			key: 'content' as EditorTab,
			label: 'Content Editor',
		},
		{
			key: 'html' as EditorTab,
			label: 'HTML',
		},
		{
			key: 'css' as EditorTab,
			label: 'CSS',
		},
	]

	const handleTabSelect = (tabKey: string) => {
		switchTab(tabKey as EditorTab)
	}

	return (
		<div
			className="editor-tabs-header-container"
			style={{
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'center',
				width: '100%',
				gap: '16px',
			}}
		>
			<CustomTabs tabs={editorTabs} activeTab={activeTab} onTabSelect={handleTabSelect} className="editor-tabs" />
			<TemplateSelector />
		</div>
	)
}

export default EditorTabs
